import '../LandingPage.css';
import {
  FaLaptopCode,
  FaMobileAlt,
  FaCloud,
  FaRobot,
  FaDatabase,
  FaShieldAlt,
} from 'react-icons/fa';

const services = [
  {
    icon: FaLaptopCode,
    title: 'Web Application Development',
    description:
      'Fast, reliable and beautiful web apps built with modern frameworks and clean architecture.',
  },
  {
    icon: FaMobileAlt,
    title: 'Responsive & Mobile-First',
    description:
      'Experiences that look and feel great on every device, from phones to widescreen displays.',
  },
  {
    icon: FaCloud,
    title: 'Cloud & Deployment',
    description:
      'Scalable cloud hosting, CI/CD pipelines and dependable production deployments.',
  },
  {
    icon: FaRobot,
    title: 'AI & Chat Integration',
    description:
      'Smart, AI-powered chat and automation that engage your customers around the clock.',
  },
  {
    icon: FaDatabase,
    title: 'APIs & Integrations',
    description:
      'Robust back-ends, data modelling and seamless integration with third-party services.',
  },
  {
    icon: FaShieldAlt,
    title: 'Security & Compliance',
    description:
      'Privacy-aware engineering with secure foundations across regulated industries.',
  },
];

function ServicesSection() {
  return (
    <section id="services" className="services-section section">
      <div className="section-content">
        <div className="section-head reveal">
          <span className="section-eyebrow">What we do</span>
          <h2 className="section-title">Services built around your goals</h2>
          <p className="section-lead">
            From first idea to production and beyond, we cover the full software
            lifecycle so you can focus on your business.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <article
                key={service.title}
                className={`service-card reveal reveal-delay-${(index % 3) + 1}`}
              >
                <div className="service-card-icon">
                  <Icon />
                </div>
                <h3 className="service-card-title">{service.title}</h3>
                <p className="service-card-text">{service.description}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default ServicesSection;
